export default [
  {
    name: 'appCollections',
    alias: 'collections',
    entry: 'https://cdn.hp.hotmart.com/app-collections/remoteEntry.js'
  },
  {
    name: 'contentConsume',
    alias: 'contentConsume',
    entry:
      'https://app-club-microfrontends-prod.cp.hotmart.com/app-club-consumer/_current/remoteEntry.js'
  },
  {
    name: 'community',
    alias: 'community',
    entry:
      'https://app-club-microfrontends-prod.cp.hotmart.com/app-membership-consume/_current/remoteEntry.js'
  },
  {
    name: 'communityManagement',
    alias: 'communityManagement',
    entry:
      'https://app-club-microfrontends-prod.cp.hotmart.com/app-membership-community-management/_current/remoteEntry.js'
  },
  {
    name: 'Gamification',
    alias: 'gamification',
    entry:
      'https://app-club-microfrontends-prod.cp.hotmart.com/app-gamification/_current/remoteEntry.js'
  },
  {
    name: 'ModerationSupport',
    alias: 'ModerationSupport',
    entry: 'https://app-membership-moderation-support.cp.hotmart.com/remoteEntry.js'
  },
  {
    name: 'MembershipChat',
    alias: 'MembershipChat',
    entry: 'https://app-membership-chat.cp.hotmart.com/remoteEntry.js'
  }
]
